import { WEATHER_DETAIL_ICON_KEYS } from 'features/Weather/config/weatherDetailIcons.config';
import { displayValue, displayValueWithUnit } from 'utils/valueFormatting/display.utils';
import NullImage from '../../../assets/images/airQuality/0.png';
import GoodImage from '../../../assets/images/airQuality/1.png';
import ModerateImage from '../../../assets/images/airQuality/2.png';
import SensitiveGroupsImage from '../../../assets/images/airQuality/3.png';
import UnhealthyImage from '../../../assets/images/airQuality/4.png';
import VeryUnhealthyImage from '../../../assets/images/airQuality/5.png';
import HazardousImage from '../../../assets/images/airQuality/6.png';

export const unknownAirQualityCategory = '*';

export const airQualityCategoryByCode = Object.freeze({
  [unknownAirQualityCategory]: Object.freeze({
    label: '?',
    color: null,
    meterImage: NullImage,
  }),
  G: Object.freeze({ label: 'Good', color: '#14FF00', meterImage: GoodImage }),
  M: Object.freeze({ label: 'Moderate', color: '#ADFF00', meterImage: ModerateImage }),
  S: Object.freeze({
    label: 'Unhealthy for Sensitive Groups',
    color: '#FFE500',
    meterImage: SensitiveGroupsImage,
  }),
  U: Object.freeze({ label: 'Unhealthy', color: '#D89B40', meterImage: UnhealthyImage }),
  V: Object.freeze({
    label: 'Very Unhealthy',
    color: '#FF701F',
    meterImage: VeryUnhealthyImage,
  }),
  H: Object.freeze({ label: 'Hazardous', color: '#BF0000', meterImage: HazardousImage }),
});

export const airQualityForecastSubTab = 'air quality forecast';

export const airQualityDetails = [
  {
    id: 'station',
    label: 'Station',
    iconKey: WEATHER_DETAIL_ICON_KEYS.AIR_QUALITY,
    getValue: (data) => displayValue(data?.air_station_name),
  },
  {
    id: 'concentration',
    label: 'Concentration',
    iconKey: WEATHER_DETAIL_ICON_KEYS.AIR_QUALITY,
    getValue: (data) => displayValueWithUnit(data?.concentration, ' ppb'),
  },
  {
    id: 'category',
    label: 'Category',
    iconKey: WEATHER_DETAIL_ICON_KEYS.AIR_QUALITY,
    getValue: (data) => getAirQualityCategoryLabel(data?.category),
    getIconProps: (data) => ({ color: getAirQualityCategoryColor(data?.category) }),
  },
];

export const getAirQualityCategoryLabel = (category) => {
  return airQualityCategoryByCode[category]?.label ?? displayValue(category);
};

export const getAirQualityCategoryColor = (category) => {
  return airQualityCategoryByCode[category]?.color ?? null;
};

export const getAirQualityCategoryMeterImage = (category) => {
  return (
    airQualityCategoryByCode[category]?.meterImage ??
    airQualityCategoryByCode[unknownAirQualityCategory].meterImage
  );
};
